import { render, staticRenderFns } from "./NormalFeedback.vue?vue&type=template&id=3275b851"
import script from "./NormalFeedback.vue?vue&type=script&lang=js"
export * from "./NormalFeedback.vue?vue&type=script&lang=js"
import style0 from "./NormalFeedback.vue?vue&type=style&index=0&id=3275b851&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports